export default "__VITE_ASSET__ab0ed756__"